import { render, staticRenderFns } from "./NotificationButton.vue?vue&type=template&id=790d94de&"
import script from "./NotificationButton.vue?vue&type=script&lang=ts&"
export * from "./NotificationButton.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationButton.vue?vue&type=style&index=0&id=790d94de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports